import React from "react";
import { useLocation } from "react-router-dom";
import "./Failure.css";

const Failure = () => {
  const { state } = useLocation();
  const error = state?.error || "An unknown error occurred";

  return (
    <div className="failure-container">
      <h1>Payment Failed</h1>
      <p>Sorry, there was an issue processing your payment.</p>
      <p>Error: {error}</p>
      <p>Please try again.</p>
    </div>
  );
};

export default Failure;
